import { useNavigate, useSearch } from "@tanstack/react-router";

import { getPostLoginRedirect } from "@/lib/whitelabel/domains";

export function usePostLoginRedirect() {
  const navigate = useNavigate();
  const search = useSearch({ strict: false }) as { redirect?: string };

  return (): void => {
    const { redirect } = search;

    // Allow only true relative paths (starts with "/" but not "//", which is protocol-relative)
    const destination =
      redirect?.startsWith("/") && !redirect.startsWith("//")
        ? redirect
        : getPostLoginRedirect();

    navigate({ href: destination });
  };
}
